import { AppConfigService } from "@core/services/config.service";
import { BasketService } from "./basket.service";
import { CheckoutService } from "./checkout.service";
import { DiscountService } from "./discount.service";
import { DpopService } from "./dpop.service";
import { EventService } from "./event.service";
import { LoaderService } from "./loader.service";
import { LoggerService } from "./logger.service";
import { RefreshSchedulerService } from "./refresh-scheduler.service";
import { ThemeService } from "../themes/theme.service";
export const CORE_SERVICES = [
  ThemeService, 
  BasketService, 
  LoaderService, 
  EventService, 
  CheckoutService, 
  AppConfigService, 
  DiscountService, 
  DpopService, 
  LoggerService, 
  RefreshSchedulerService,
];
